import {useMemo} from "react";
import {Colors, Container, Text} from "@bounce/shared/ui";
import {formatDateTime} from "@bounce/shared/helpers";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../store/definitions";
import {changeExpandedStatus} from "../store/actions/genericActions";
import {IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const Header = () => {
  const startedAt = useMemo(() => formatDateTime(new Date()), []);
  const dispatch = useDispatch();

  const expanded = useSelector((state: AppState) => state.session.expanded);

  const closeChat = () => {
    dispatch(changeExpandedStatus({expanded: false}));
  };

  return (
    <Container fullWidth sx={{gap: 0}}>
      <Container fullWidth row sx={{justifyContent: "flex-end"}}>
        <IconButton aria-label="close" size="small" onClick={closeChat}>
          <CloseIcon fontSize="inherit" sx={{color: Colors.primary._700}} />
        </IconButton>
      </Container>
      <Container sx={{alignItems: "center", justifyContent: "space-between", pb: "12px", gap: 0}}>
        <Text
          variant={"inter500"}
          color={Colors.primary._700}
          sx={{lineHeight: "14px", fontStyle: "italic", textAlign: "center"}}
        >
          Live Chat
        </Text>
        <Text
          size={12}
          fontWeight={400}
          color={Colors.primary._500}
          sx={{lineHeight: "18px", textAlign: "center", mt: "2px"}}
        >
          Started {startedAt}
        </Text>
      </Container>{" "}
    </Container>
  );
};
